import './IndividualBreak.scss';

import React from 'react';
import Icon from 'fe-design-base/atoms/Icon';
import Button from 'fe-design-base/molecules/Button/Button';
import ToolTip from 'fe-design-base/molecules/Tooltip';
import PropTypes from 'prop-types';

import { cxHelpers } from 'util/className';
import { toI18n } from 'util/i18n';
const { cxEl } = cxHelpers('IndividualBreak');

function BreakDeleteButton({ onClick, disabled }) {
  return (
    <Button
      variant="tertiary"
      className={cxEl('deleteButton')}
      onClick={onClick}
      disabled={disabled}
    >
      <ToolTip
        content={toI18n('timecard_modal_v3.timebreaks_section.delete_break')}
      >
        <Icon
          iconName="Delete"
          color={disabled ? 'mono500' : 'red300'}
          size="medium"
        />
      </ToolTip>
    </Button>
  );
}

BreakDeleteButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default BreakDeleteButton;
